/* ============================================================
   CTF Card Image Cycle — Create FUT
   Efecto secuencial en cascada para las product cards
   (.ctf-card): cada 1 segundo cambia la imagen de UNA card
   por vez, empezando por la primera y avanzando en orden hasta
   la última, en loop.
   - Grupos independientes (cada uno con su propia secuencia):
       · grilla de la página de colección (.ctf-collection-page)
       · home: carrousel "Make your Own" (#ctf-makeown-track)
       · home: carrousel "Featured cards" (#ctf-trending-track,
         incluye los clones del marquee)
   - Cada card cicla por TODAS las <img> dentro de
     .ctf-card-img-wrap (hoy: primaria + secundaria).
   - Imagen "base" por grupo: la primaria, salvo en Make your Own
     que muestra la secundaria por defecto (y asoma la primaria).
   - Solo cambia cards visibles en viewport (IntersectionObserver).
   - Se pausa con la pestaña oculta y respeta
     prefers-reduced-motion.
   ============================================================ */
(function () {
  'use strict';

  var CYCLE_MS = 1000;      // intervalo entre cambios (una card por tick y por grupo)
  var SHOW_MS = 1000;       // cuánto se sostiene la imagen alternativa antes de volver a la base
  var FADE_MS = 350;        // duración del crossfade

  // base: índice de la imagen que se muestra por defecto
  // threshold: fracción visible para ser elegible (en carrouseles
  // evita elegir cards cortadas en el borde)
  var GROUPS = [
    { container: '.ctf-collection-page', base: 0, observer: { rootMargin: '100px' } },
    { container: '#ctf-makeown-track',   base: 1, observer: { threshold: 0.6 } },
    { container: '#ctf-trending-track',  base: 0, observer: { threshold: 0.6 } }
  ];

  // Respetar usuarios con movimiento reducido
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function getImgs(card) {
    var wrap = card.querySelector('.ctf-card-img-wrap');
    if (!wrap) return [];
    return Array.prototype.slice.call(wrap.querySelectorAll('img'));
  }

  function injectStyles() {
    // Pisan cualquier regla hover existente
    var style = document.createElement('style');
    style.textContent =
      '.ctf-card.ctf-cycling .ctf-card-img-wrap img{' +
        'transition:opacity ' + FADE_MS + 'ms ease;' +
      '}' +
      '.ctf-card.ctf-cycling .ctf-card-img-wrap img.ctf-cycle-hidden{opacity:0 !important;}' +
      '.ctf-card.ctf-cycling .ctf-card-img-wrap img.ctf-cycle-visible{opacity:1 !important;}' +
      /* Hover: siempre mostrar la imagen secundaria, gane a quien gane el ciclo */
      '.ctf-card.ctf-cycling .ctf-card-img-wrap:hover img{opacity:0 !important;}' +
      '.ctf-card.ctf-cycling .ctf-card-img-wrap:hover img.ctf-card-img-secondary{opacity:1 !important;}' +
      /* Cards con base secundaria (Make your Own): al hover, la primaria */
      '.ctf-card.ctf-cycling[data-ctf-base="1"]:hover .ctf-card-img-wrap img{opacity:0 !important;}' +
      '.ctf-card.ctf-cycling[data-ctf-base="1"]:hover .ctf-card-img-wrap img.ctf-card-img-primary{opacity:1 !important;}';
    document.head.appendChild(style);
  }

  function setup(card, base) {
    var imgs = getImgs(card);
    if (imgs.length < 2) return false; // nada que rotar
    if (base >= imgs.length) base = 0;

    card.classList.add('ctf-cycling');
    card._ctfBase = base;
    card._ctfPeekPos = 0;
    card._ctfVisible = false;
    if (base !== 0) card.setAttribute('data-ctf-base', String(base));
    imgs.forEach(function (img, i) {
      img.classList.toggle('ctf-cycle-visible', i === base);
      img.classList.toggle('ctf-cycle-hidden', i !== base);
    });
    return true;
  }

  // Forzar la carga de las imágenes lazy de una card visible para que el swap no parpadee
  function eagerLoad(card) {
    if (card._ctfEager) return;
    card._ctfEager = true;
    getImgs(card).forEach(function (img) {
      if (img.getAttribute('loading') === 'lazy') img.setAttribute('loading', 'eager');
    });
  }

  function show(card, idx) {
    getImgs(card).forEach(function (img, i) {
      img.classList.toggle('ctf-cycle-visible', i === idx);
      img.classList.toggle('ctf-cycle-hidden', i !== idx);
    });
  }

  function step(card) {
    var imgs = getImgs(card);
    if (imgs.length < 2) return;
    var base = card._ctfBase;
    // Peek: qué imagen alternativa toca en este turno (todas menos la base, secuencial entre turnos)
    var others = [];
    for (var i = 0; i < imgs.length; i++) if (i !== base) others.push(i);
    var peek = others[card._ctfPeekPos % others.length];
    // No mostrarla hasta que esté cargada (evita flash en blanco)
    if (!imgs[peek].complete) return;
    show(card, peek);
    card._ctfPeekPos = (card._ctfPeekPos + 1) % others.length;
    // Volver SIEMPRE a la base después de sostener la alternativa
    clearTimeout(card._ctfRevert);
    card._ctfRevert = setTimeout(function () { show(card, base); }, SHOW_MS);
  }

  function isHovered(card) {
    try { return card.matches(':hover'); } catch (e) { return false; }
  }

  function tick(group) {
    var cards = group.cards;
    // Avanzar el puntero hasta la próxima card visible (una sola por tick)
    for (var hops = 0; hops < cards.length; hops++) {
      group.pointer = (group.pointer + 1) % cards.length;
      var card = cards[group.pointer];
      if (card._ctfVisible && !isHovered(card)) {
        step(card);
        return;
      }
    }
    // ninguna card visible: no hacer nada este tick
  }

  function initGroup(def) {
    var container = document.querySelector(def.container);
    if (!container) return null;
    var nodes = container.querySelectorAll('.ctf-card');
    if (!nodes.length) return null;

    var group = { cards: [], pointer: -1 };

    var observer = ('IntersectionObserver' in window)
      ? new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var visible = entry.isIntersecting &&
              entry.intersectionRatio >= (def.observer.threshold || 0);
            entry.target._ctfVisible = visible;
            if (visible) eagerLoad(entry.target);
          });
        }, def.observer)
      : null;

    // group.cards conserva el orden del DOM: la secuencia arranca en la primera
    Array.prototype.forEach.call(nodes, function (card) {
      if (card.classList.contains('ctf-cycling')) return; // ya tomada por otro grupo
      if (!setup(card, def.base)) return;
      group.cards.push(card);
      if (observer) {
        observer.observe(card);
      } else {
        card._ctfVisible = true; // fallback: todas elegibles
        eagerLoad(card);
      }
    });

    return group.cards.length ? group : null;
  }

  function init() {
    var groups = [];
    GROUPS.forEach(function (def) {
      var g = initGroup(def);
      if (g) groups.push(g);
    });
    if (!groups.length) return;

    injectStyles();
    setInterval(function () {
      if (document.hidden) return;
      groups.forEach(tick);
    }, CYCLE_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
